// extracted by mini-css-extract-plugin
module.exports = {"benefitsBackground":"BenefitsSection_benefitsBackground__LMyGf"};